import { APIClient } from 'infra/APIClient'
import { APIConfig } from 'types/definitions'
import { RelationManagerResource } from './dtos/relation-manager'

interface CSDeskResponse<T> {
  success: boolean
  data: T
}

/**
 * Client for csdesk api.
 */
export interface CSDeskAPI {
  relationManager: RelationManagerAPI
}

export function createCSDeskAPI(opts: APIConfig): CSDeskAPI {
  return {
    relationManager: new RelationManagerAPI(opts),
  }
}

export class RelationManagerAPI extends APIClient {
  getForJob(jobId: string): Promise<CSDeskResponse<RelationManagerResource>> {
    return this.client
      .get<
        CSDeskResponse<RelationManagerResource>
      >(`/api/v1/rms/job/${encodeURIComponent(jobId)}`)
      .then(this._data)
  }
}
